import React from "react";
import { CalendarIcon, ClockIcon, MonitorIcon } from "./Icons";
import { CountdownStrip } from "./CountdownStrip";
import { RegistrationForm } from "./RegistrationForm";
import {
  HeroWrapper,
  HeroContainer,
  HeroContent,
  HeroBadge,
  PulseDot,
  HeroTitle,
  HeroTitleAccent,
  HeroSubtitle,
  HeroMeta,
  HeroMetaItem,
  HeroCtaGroup,
  BtnPrimary,
  BtnSecondary,
} from "../Styles";
import useWebinar from "../../../../hooks/useWebinar";

const ICON_COMPONENT_MAP = {
  calendar: (size) => <CalendarIcon size={size} />,
  clock: (size) => <ClockIcon size={size} />,
  monitor: (size) => <MonitorIcon size={size} />,
};

function HeroBanner() {
  const { config } = useWebinar();
  const heroData = config?.hero;

  if (!heroData) return null;

  return (
    <HeroWrapper id="hero">
      <HeroContainer>
        <HeroContent>
          <HeroBadge>
            <PulseDot />
            {heroData.badgeText}
          </HeroBadge>

          <HeroTitle>
            {heroData.titleLine1}
            <HeroTitleAccent>{heroData.titleLine2}</HeroTitleAccent>
          </HeroTitle>

          <HeroSubtitle>{heroData.subtitle}</HeroSubtitle>

          <HeroMeta>
            {heroData.meta?.map((metaItem, index) => (
              <HeroMetaItem key={index}>
                {ICON_COMPONENT_MAP[metaItem.icon]?.(18) ?? null}
                <span>
                  <strong>{metaItem.label}</strong>
                  {metaItem.sublabel ? `, ${metaItem.sublabel}` : ""}
                </span>
              </HeroMetaItem>
            ))}
          </HeroMeta>

          <HeroCtaGroup>
            <BtnPrimary href={heroData.primaryCta?.href}>
              {heroData.primaryCta?.label}
            </BtnPrimary>
            <BtnSecondary href={heroData.secondaryCta?.href}>
              {heroData.secondaryCta?.label}
            </BtnSecondary>
          </HeroCtaGroup>

          {heroData.showCountdown && <CountdownStrip />}
        </HeroContent>

        {heroData.showRegistrationForm && <RegistrationForm />}
      </HeroContainer>
    </HeroWrapper>
  );
}

export { HeroBanner };
